/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts"/>
///<reference path="ym-section-base.ts"/>


module Meevo.Plugins.YieldManagementProgram {

    import IYMStrategy = Meevo.Plugins.YieldManagementStrategy.IYMStrategy;

    export class YieldManagerStrategyMainSection extends YmSectionBase {
        selectedStrategy: IYMStrategy;
        toMin = new Date();
        timeSpanFormat: string = "HH:mm:ss";

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.model = new YMProgramModel({
                objectState: Model.ObjectStateEnum.Active,
                strategyId: this.selectedStrategy.strategyId,
                homeLocationId: this.identityService.current().locationId,
                locationId: this.identityService.current().locationId,
            } as IYMProgram);

            this.postCancel();
            this.takeBackup();
        }

        public modelIsValid() {
            return this.model.isValid;
        }

        public sectionModelRetrieved(): void {
            this.timeSpansToDates();
            super.sectionModelRetrieved();
        }

        public preSave(): void {
            this.datesToTimeSpans();
            super.preSave();
        }

        private timeSpansToDates(): void {
            for (const timeRange of this.model.programTimeRanges) {
                if (angular.isString(timeRange.startTime))
                    timeRange.startTime = moment(timeRange.startTime, this.timeSpanFormat).toDate();
                if (angular.isString(timeRange.endTime))
                    timeRange.endTime = moment(timeRange.endTime, this.timeSpanFormat).toDate();
            }
        }

        private datesToTimeSpans(): void {
            for (const timeRange of this.model.programTimeRanges) {
                if (angular.isDate(timeRange.startTime))
                    timeRange.startTime = moment(timeRange.startTime).format(this.timeSpanFormat);
                if (angular.isDate(timeRange.endTime))
                    timeRange.endTime = moment(timeRange.endTime).format(this.timeSpanFormat);
            }
        }
    }
}
